import { Outlet } from 'react-router-dom';
import { AppShell } from './app-shell';

export function FoundationRoot(): JSX.Element {
  return (
    <AppShell>
      <Outlet />
    </AppShell>
  );
}
